// @ts-nocheck
import * as React from 'react';
import RequestListWrapper from './RequestList.style';
import type { RequestListProps } from './RequestList.types';

const RequestList = ({
  onResetList,
  onToggleModal,
  selectedPrograms = 0,
}: RequestListProps): React.ReactElement<any> => {
  const isOpen = selectedPrograms > 0 ? 'is-open' : '';
  return (
    <RequestListWrapper className={isOpen}>
      <div className={`request-list__container ${isOpen}`}>
        <span
          className='request-list__reset'
          onClick={onResetList}
          onKeyPress={onResetList}
          role='button'
          tabIndex='0'
        >
          Reset list
        </span>
        <span
          className='request-list__request'
          onClick={onToggleModal}
          onKeyPress={onToggleModal}
          role='button'
          tabIndex={-1}
        >
          Request info ({selectedPrograms})
        </span>
      </div>
    </RequestListWrapper>
  );
};

export default RequestList;
